import React from 'react'
import PropTypes from 'prop-types'
import { TrashIcon, EyeOffIcon } from '@heroicons/react/solid'

// Shown when a submission exists but this visitor can't see it. Deleted and
// private are the two reasons; unlisted is visible by direct link and never
// lands here. Keep the copy in sync with app/views/auditions/_unavailable.html.erb,
// which is the logged-out server-rendered twin of this page.
const COPY = {
  deleted: {
    Icon: TrashIcon,
    body: "This one's gone. They deleted it, and...well, I'm kinda sad about it. I bet it was great."
  },
  private: {
    Icon: EyeOffIcon,
    body: "So... this submission is marked as private and you don't have permission. Sorry."
  }
}

const SubmissionUnavailable = ({ reason, project }) => {
  const { Icon, body } = COPY[reason] || COPY.private

  return (
    <div className="relative block w-full border-2 border-gray-300 dark:border-gray-600 border-dashed rounded-lg p-12 text-center">
      <Icon className="mx-auto h-12 w-12 text-gray-400" aria-hidden="true" />
      <span className="mt-4 block text-base font-medium text-gray-900 dark:text-gray-200">{body}</span>
      {/* Plain anchors, not react-router Links: /projects/:slug is server
          rendered and App.jsx has no route for it, so a Link would push
          history onto a Switch that matches nothing and render a blank page. */}
      <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-3">
        { project && <a href={`/projects/${project.slug}`} className="text-sm text-cccblue hover:underline">
          Back to {project.name}
        </a> }
        <a href="/" className="text-sm text-cccblue hover:underline">
          Go find something else
        </a>
      </div>
    </div>
  )
}

export default SubmissionUnavailable

SubmissionUnavailable.propTypes = {
  reason: PropTypes.oneOf(['deleted', 'private']).isRequired,
  project: PropTypes.shape({
    name: PropTypes.string,
    slug: PropTypes.string
  })
}
